import { useState, useEffect } from "react";

const getTimeRemaining = (live_period_to) => {
  const now = new Date().getTime();
  const target = new Date(live_period_to.replace(/-/g, "/")).getTime();
  const diff = target - now;
  const total = diff > 0 ? diff : 0;
  return {
    hours: Math.floor(total / (1000 * 60 * 60)),
    minutes: Math.floor((total / (1000 * 60)) % 60),
    seconds: Math.floor((total / 1000) % 60),
  };
};

const BarTimer = ({ live_period_to }) => {
  const [timer, setTimer] = useState(getTimeRemaining(live_period_to));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(getTimeRemaining(live_period_to));
    }, 1000);
    return () => clearInterval(interval);
  }, [live_period_to]);

  return (
    <div className="cdtimer_v2">
      <div className="cdtimercaption_v2">Ending in</div>
      <div className="time_v2">{timer.hours.toString().padStart(2, "0")}</div>
      <div>:</div>
      <div className="time_v2">{timer.minutes.toString().padStart(2, "0")}</div>
      <div>:</div>
      <div className="time_v2">{timer.seconds.toString().padStart(2, "0")}</div>
    </div>
  );
};

export default BarTimer;
